import BaseAPI from "../api";

const path: string = "/visa-type";

export class VisaTypeApi extends BaseAPI {
  static list(query?: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
}
